let PROJECT_ID;
let GOOGLE_CLIENT_ID;
let FIREBASE_CONFIG;
let PRODUCTION;

if (process.env.GATSBY_PROJECT_ENV === "production") {
  PRODUCTION = true;
  PROJECT_ID = "thriller-79838";
  GOOGLE_CLIENT_ID =
    "1001289103149-nig59nj738s2p764l9bkpcpg1mfacl3a.apps.googleusercontent.com";
  FIREBASE_CONFIG = {
    apiKey: "AIzaSyCuvMcvHsp9uOcZ2EEV7q6mZTIVUS3fO54",
    authDomain: "thriller-79838.firebaseapp.com",
    databaseURL: "https://thriller-79838.firebaseio.com",
    projectId: "thriller-79838",
    storageBucket: "thriller-79838.appspot.com",
    messagingSenderId: "1001289103149"
  };
} else {
  PRODUCTION = false;
  PROJECT_ID = "thriller-dev";
  GOOGLE_CLIENT_ID =
    "589897270760-j0ovb20aetugbat8lnd3bpk7go0m5div.apps.googleusercontent.com";
  FIREBASE_CONFIG = {
    apiKey: "AIzaSyDPeXRwgzf5cACqQo50iKkNt5bCVSuOaeE",
    authDomain: "thriller-dev.firebaseapp.com",
    databaseURL: "https://thriller-dev.firebaseio.com",
    projectId: "thriller-dev",
    storageBucket: "thriller-dev.appspot.com",
    messagingSenderId: "589897270760"
  };
}

export default {
  googleClientId: GOOGLE_CLIENT_ID,
  firebaseFunctionURL: `https://us-central1-${PROJECT_ID}.cloudfunctions.net`,
  production: PRODUCTION,
  firebaseConfig: FIREBASE_CONFIG,
  adminDatabase: `https://${PROJECT_ID}-admin.firebaseio.com`,
  supportDatabase: `https://${PROJECT_ID}-support.firebaseio.com`
};



// WEBPACK FOOTER //
// ./src/config/index.js